module.exports = __webpack_public_path__ + "img/other.ce1da0fe.jpg";